module.exports = "/img/badge.svg?66547c2c6432b2a67b8cebab3095d6ab";